const GAME_SETTINGS = {
    "gameResolution":{
        "width": 350,
        "height": 350,
        "squareArea": 12.5
    },
    "speed": {
        "initial": 300,
        "minSpeed": 100,
        "speedDecay": 25 
    }
};

export default GAME_SETTINGS;